import React from "react";
import { useAppSelector } from "common/hooks/storeHooks";
import { LiveChatWidget, WidgetState } from "@livechat/widget-react";
import { currentUser as currentUserSelector } from "common/selectors/user.selectors";
import { currentUserOrg } from "common/selectors/org.selectors";
import { chatHidden as chatHiddenSelector } from "common/selectors/common.selectors";
import { setupUser } from "common/services/LiveChat.service";

export const LiveChat: React.FC<{}> = () => {
  const currentUser = useAppSelector(currentUserSelector);
  const currentOrg = useAppSelector(currentUserOrg);
  const chatHidden = useAppSelector(chatHiddenSelector);
  const [visibility, setVisibility] = React.useState<WidgetState["visibility"]>(chatHidden ? "hidden" : "minimized");

  React.useEffect(() => {
    setupUser(currentUser, currentOrg);
  }, [currentUser, currentOrg]);

  React.useEffect(() => {
    setVisibility(chatHidden ? "hidden" : "minimized");
  }, [chatHidden]);

  return (
    <LiveChatWidget
      license="17886525"
      visibility={visibility}
      onVisibilityChanged={(data) => setVisibility(data.visibility)}
    />
  );
};
